export default [
  { 
    header: "Menú", 
    icon: "mdi mdi-dots-horizontal" 
  }, 
  {
    id: "1",
    icon: "map",
    title: "Monitoreo",
    i18n: "Monitoreo",
    to: "/monitoreo",
  },
  {
    id: "2",
    icon: "tablet",
    title: "Dispositivos",
    i18n: "Dispositivos",
    to: "/dispositivos",
  },
  {
    id: "3",
    icon: "clock",
    title: "Historial",
    i18n: "Histórico",
    to: "/historico",
  },
  {
    id: "4",
    icon: "alert-circle",
    title: "Geocercas",
    i18n: "Geocercas",
    to: "/geocercas",
  },
  {
    id: "5",
    icon: "bar-chart-2",
    title: "Estadísticas",
    i18n: "Estadísticas",
    to: "/estadisticas",
  },
  {
    id: "6",
    icon: "users",
    title: "Usuarios",
    i18n: "Usuarios",
    to: "/usuarios",
  },
  {
    id: "7",
    icon: "home",
    title: "Grupos",
    i18n: "Grupos",
    to: "/grupos",
  },
  {
    id: "8",
    icon: "folder",
    title: "Marcas",
    i18n: "Marcas",
    to: "/marcas",
  },
  {
    id: "9",
    icon: "folder-plus",
    title: "Modelos",
    i18n: "Modelos",
    to: "/modelos",
  },
  {
    id: "10",
    icon: "book-open",
    title: "Bitácora",
    i18n: "Bitácora",
    to: "/acciones",
  },
  {
    id: "11",
    icon: "archive",
    title: "Log de Errores",
    i18n: "Log de Errores",
    to: "/logerrores",
  },
  {
    id: "12",
    icon: "settings",
    title: "Configuraciones",
    i18n: "Configuraciones",
    to: "/configuraciones",
  },
];
